(() => {
  const flows = new Set();
  const draw = (f) => {
    const a = f.querySelector('[data-leo-from]'); const b = f.querySelector('[data-leo-to]'); const p = f.querySelector('[data-leo-wave]');
    if (!a || !b || !p) return;
    const box = f.getBoundingClientRect(); const ra = a.getBoundingClientRect(); const rb = b.getBoundingClientRect();
    const x1 = ra.right - box.left + 6; const y1 = ra.top + ra.height / 2 - box.top;
    const x2 = rb.left - box.left - 8; const y2 = rb.top + rb.height / 2 - box.top;
    const dx = x2 - x1; const amp = Math.max(14, Math.min(26, dx * 0.22));
    p.setAttribute('d', `M${x1.toFixed(1)} ${y1.toFixed(1)} C ${(x1 + dx * 0.3).toFixed(1)} ${(y1 - amp).toFixed(1)}, ${(x1 + dx * 0.55).toFixed(1)} ${(y2 + amp).toFixed(1)}, ${x2.toFixed(1)} ${y2.toFixed(1)}`);
  };
  let raf = 0;
  const loop = () => { flows.forEach(draw); raf = flows.size ? requestAnimationFrame(loop) : 0; };
  const io = new IntersectionObserver((en) => {
    en.forEach((e) => { if (e.isIntersecting) flows.add(e.target); else flows.delete(e.target); });
    if (flows.size && !raf) raf = requestAnimationFrame(loop);
  });
  const init = (root) => root.querySelectorAll('[data-leo-flow]').forEach((f) => { if (f.dataset.ready) return; f.dataset.ready = '1'; draw(f); io.observe(f); });
  init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();